function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { CardBuilder } from "./Helpers/CardBuilder";
import { GroupsApiService } from "./Services/GroupsApiService";
import { OAuthService } from "./Services/OAuthService";
import { UserService } from "./Services/UserService";
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { Configuration } from "./Shared/Configuration";
export var MppMyGroups = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppMyGroups, _ComponentBase);

  var _super = _createSuper(MppMyGroups);

  function MppMyGroups() {
    var _this;

    _classCallCheck(this, MppMyGroups);

    _this = _super.call(this);
    _this.config = new Configuration();
    _this._cloudUrl = '';
    _this._appRoot = _this.config.GetAppRoot(); // Get COMMON, MPCloudUrlPrefix

    var self = _assertThisInitialized(_this);

    _this.config.GetConfigurationSetting("MPCloudUrlPrefix").then(function (cloudUrl) {
      self._cloudUrl = cloudUrl;
    });

    return _this;
  }

  _createClass(MppMyGroups, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      var _this2 = this;

      console.log('Attribute changed', newValue);

      if (!!this._$resultsContainer) {
        this.loadAttributes();
        UserService.GetCurrentUser().then(function (userInfo) {
          if (!!userInfo) {
            _this2.GetMyGroups();
          }
        });
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.hideGroupLife = this.getAttribute("hidegrouplife") || false;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N(MppMyGroups.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this3._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this3._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context.sent;
                this._i18n = i18n; // Load initial values of tag attributes:

                this.loadAttributes(); // Root Html

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mppw-form-wrapper" id="myGroupsWrapper" style="display: none;"><h1>${ i18n.pageTitle }</h1></div><div id="loadingContainer"><i class="mppw-spinner"></i></div><div id="emptyContainer" style="display: none;"></div><div id="loginButtonContainer" class="mppw-centered" style="display: none;"><div id="myGroupsNotLoggedIn" class="mppw-alert mppw-alert__warning"><div class="mppw-alert__icon"></div><span class="mppw-alert__text">${this._i18n.pleaseLoginMessage}</span></div><input type="button" class="mppw-btn primary" id="loginButton" value="Login"/></div><div class="resultsContainer mppw-card--grid" id="resultsContainer"></div></div>` ;
                this._$myGroupsWrapper = this._root.querySelector("#myGroupsWrapper");
                this._$resultsContainer = this._root.querySelector("#resultsContainer");
                this._$loadingContainer = this._root.querySelector("#loadingContainer");
                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$loginButtonContainer = this._root.querySelector("#loginButtonContainer");
                this._$loginButton = this._root.querySelector("#loginButton");
                this._groupsService = new GroupsApiService(); // Try logging in user

                this.TryLoginUser();

                this._$loginButton.addEventListener("click", function () {
                  OAuthService.SignIn();
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "TryLoginUser",
    value: function TryLoginUser() {
      var _this4 = this;

      UserService.GetCurrentUser().then(function (userInfo) {
        _this4._$loginButtonContainer.style.display = "none";
        _this4._$myGroupsWrapper.style.display = "";

        _this4.GetMyGroups();
      }, function () {
        _this4._$myGroupsWrapper.style.display = "none";
        _this4._$loginButtonContainer.style.display = "";
        _this4._$loadingContainer.style.display = "none";
      });
    }
  }, {
    key: "GetBadgeText",
    value: function GetBadgeText(myGroupData) {
      if (!!myGroupData) {
        var badgeText = '';

        if (myGroupData.isUserLeader === true && myGroupData.meetsOnline === true) {
          badgeText = this._i18n.meetsOnlineLeaderLabel;
        } else if (myGroupData.isUserLeader === true) {
          badgeText = this._i18n.leaderLabel;
        } else if (myGroupData.meetsOnline === true) {
          badgeText = this._i18n.meetsOnlineLabel;
        }

        return badgeText;
      }
    }
  }, {
    key: "GetGroupLifeButton",
    value: function GetGroupLifeButton(myGroupData) {
      if (!!myGroupData) {
        var groupLifeButton = '';

        if (this.hideGroupLife === 'false' || this.hideGroupLife === false) {
          groupLifeButton = CardBuilder.BuildCloudAppDetailsButton(myGroupData.groupId, "https://".concat(this._cloudUrl, ".cloudapps.ministryplatform.cloud/apps/grouplife/"), this._i18n.groupLifeButtonLabel);
        }

        return groupLifeButton;
      }
    }
  }, {
    key: "GetMyGroups",
    value: function GetMyGroups() {
      var _this5 = this;

      this._$resultsContainer.innerHTML = "";
      this._$loadingContainer.style.display = "";

      this._groupsService.GetMyGroups().then(function (data) {
        if (data.length <= 0) {
          // No groups associated to user
          _this5._$emptyContainer.style.display = "";
          _this5._$emptyContainer.innerHTML += "<div id=\"myGroupsEmpty\" class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(_this5._i18n.noGroupsFoundMessage, "</span>\n\t\t\t\t\t\t</div>");
          _this5._$loadingContainer.style.display = "none";
        } else {
          // Loop through each group and build page with cards
          _this5._$emptyContainer.style.display = "none";
          var resultsContainerHTML = "";

          for (var i = 0; i < data.length; i++) {
            var _data$i = _objectSpread({}, data[i]),
                availableOnline = _data$i.availableOnline,
                congregationAddress = _data$i.congregationAddress,
                congregationId = _data$i.congregationId,
                description = _data$i.description,
                endDate = _data$i.endDate,
                groupId = _data$i.groupId,
                groupName = _data$i.groupName,
                groupRoleId = _data$i.groupRoleId,
                imageUrl = _data$i.imageUrl,
                isUserLeader = _data$i.isUserLeader,
                meetingDay = _data$i.meetingDay,
                meetingDayId = _data$i.meetingDayId,
                meetsOnline = _data$i.meetsOnline,
                meetingTime = _data$i.meetingTime,
                offsiteMeetingAddress = _data$i.offsiteMeetingAddress,
                offsiteMeetingAddressId = _data$i.offsiteMeetingAddressId,
                primaryContactId = _data$i.primaryContactId,
                startDate = _data$i.startDate;

            var groupLocation = offsiteMeetingAddress ? offsiteMeetingAddress : congregationAddress;
            var groupLocationString = null;

            if (groupLocation) {
              var _groupLocation = _objectSpread({}, groupLocation),
                  addressLine1 = _groupLocation.addressLine1,
                  addressLine2 = _groupLocation.addressLine2,
                  city = _groupLocation.city,
                  stateRegion = _groupLocation.stateRegion,
                  postalCode = _groupLocation.postalCode;

              groupLocationString = "".concat(!!addressLine1 ? addressLine1 : "").concat(!!addressLine2 ? " " + addressLine2 : "").concat(!!city ? ", " + city : "").concat(!!stateRegion ? ", " + stateRegion : "").concat(!!postalCode ? ", " + postalCode : "");
              groupLocationString = groupLocationString ? groupLocationString : '';
            }

            var displayBadge = isUserLeader || meetsOnline;

            var badgeText = _this5.GetBadgeText(data[i]);

            var groupLifeButton = _this5.GetGroupLifeButton(data[i]);

            var subtitlesArr = CardBuilder.BuildGroupSubtitlesArr(groupLocationString, meetingDay, meetingTime, startDate, _this5._i18n.alreadyMeetingLabel);
            resultsContainerHTML += CardBuilder.BuildCard(CardBuilder.BuildBadge(displayBadge, badgeText) + CardBuilder.BuildImage(imageUrl, 'event'), CardBuilder.BuildText(groupName, subtitlesArr, description), groupLifeButton);
          }

          _this5._$resultsContainer.innerHTML = resultsContainerHTML ? resultsContainerHTML : _this5._i18n.noGroupsFoundMessage;
          _this5._$loadingContainer.style.display = "none";
        }
      })["catch"](function (error) {
        console.error(error);
        _this5._$loadingContainer.style.display = "none";
      });
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "My Groups",
        tag: "mpp-my-groups",
        configurationItems: [{
          name: "Hide GroupLife",
          attribute: "hidegrouplife",
          description: "Hides GroupLife button. When False, MyGroups displays GroupLife button for authenticated Group Leaders.",
          required: false,
          type: "bool"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["hidegrouplife"];
    }
  }]);

  return MppMyGroups;
}(ComponentBase);
MppMyGroups.registerComponent(MppMyGroups.WidgetDetails.tag, MppMyGroups);